// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.css\"","textBlack":"#161616","borderBlack":"#777777","borderGrey":"#d5dfdf","body":"_2lYHSCAcM6vA2s-47YYZeS","sectionButton":"_2wJc_kmGtSgV9_Q0ysbGp5 _2lYHSCAcM6vA2s-47YYZeS","disabled":"_28oKD9gch7dpPoWuLLhyiT","sectionInfoOpen":"_32EJl11pNJ9aKOeiYCEH-v","sectionInfoClose":"_3agh-g8jy6tgca3JzBjnWc","sectionTable":"_2vCl21AQFvJweJOkNjmPGF","tableColumn":"_2MmqJFwa_lrpH0m5DesgtJ","tableRow":"_2wf1n1yH6bhlPZV1bxEy6p","link":"_2Tcx52UYdq7WDdfABtcmU-"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/help/section-content/SectionContent.css
// module id = 1132
// module chunks = 2